// src/portal/contexts/illustrations/components/BookLibrary/components/LibraryFilters.tsx

'use client';

import { useTranslations } from 'next-intl';
import type { IllustrationStatus } from '../../../types';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/components/ui/select';

type FilterOption = 'all' | IllustrationStatus;

interface LibraryFiltersProps {
  filter: FilterOption;
  onFilterChange: (filter: FilterOption) => void;
}

export function LibraryFilters({
  filter,
  onFilterChange,
}: LibraryFiltersProps) {
  const t = useTranslations('illustrations.library.filters');

  return (
    <Select value={filter} onValueChange={(v) => onFilterChange(v as FilterOption)}>
      <SelectTrigger className="w-[110px] sm:w-[140px] h-8 sm:h-9 text-xs sm:text-sm" data-testid="illustration-library-filter-select">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{t('filterOptions.all')}</SelectItem>
        <SelectItem value={'ready' as const}>{t('filterOptions.ready')}</SelectItem>
        <SelectItem value={'generating' as const}>{t('filterOptions.generating')}</SelectItem>
        <SelectItem value={'draft' as const}>{t('filterOptions.draft')}</SelectItem>
        <SelectItem value={'failed' as const}>{t('filterOptions.failed')}</SelectItem>
      </SelectContent>
    </Select>
  );
}
